// extracted by mini-css-extract-plugin
module.exports = {"icon-small":"index_icon-small_aVn2f"};